import { bs } from "../../../../date-fns/locale/bs.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    bs
  }
};